import { WidgetConfig, WidgetElementType } from "@redotech/redo-model/widget";
import { RedoToggleElement } from "../cart-app";

export function hasValidButtonSelectors(
  toggles: {
    redoToggleElements: RedoToggleElement[];
    widgetConfig?: WidgetConfig;
  }[],
): boolean {
  const usingWidgetConfigs = toggles.some(
    ({ redoToggleElements, widgetConfig }) => !!widgetConfig,
  );

  if (!usingWidgetConfigs) {
    if (
      toggles.every(
        ({ redoToggleElements, widgetConfig }) =>
          redoToggleElements.length === 0,
      )
    ) {
      return false;
    }
    return true;
  }

  const checkoutButtonElements = toggles.filter(
    ({ redoToggleElements, widgetConfig }) => {
      return (
        widgetConfig?.elementType === WidgetElementType.BOTH_CHECKOUT_BUTTONS ||
        widgetConfig?.elementType ===
          WidgetElementType.COVERAGE_CHECKOUT_BUTTON ||
        widgetConfig?.elementType ===
          WidgetElementType.NON_COVERAGE_CHECKOUT_BUTTON
      );
    },
  );

  if (
    checkoutButtonElements.every(
      ({ redoToggleElements, widgetConfig }) => redoToggleElements.length === 0,
    )
  ) {
    return false;
  }

  return true;
}
